import React, { Component } from 'react'

export default class Spinner extends Component {
    render() {
        return (
            <div>
                <img alt='loading...' src='https://media2.giphy.com/media/j5V3Y28zYZ3gXP05jv/giphy.gif' />
            </div>
        )
    }
}
